import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d8ro7psjgj4v45gj7ecg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      // silently handle
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-foreground-950 rounded-t-3xl mx-4 md:mx-6">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 mb-16">
          <div className="md:col-span-5">
            <h3 className="text-2xl md:text-3xl font-heading font-light text-background-50 mb-3">
              Zapisz się
            </h3>
            <p className="text-sm text-background-50/50 leading-relaxed mb-6 max-w-sm">
              Otrzymuj najnowsze aktualizacje i nowe arkusze{' '}
              <strong className="text-background-50/70">Kakobuy Spreadsheet</strong> bezpośrednio na swoją skrzynkę.
            </p>
            <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Wpisz email"
                required
                className="flex-1 bg-transparent border-b border-background-50/20 text-background-50 text-sm py-2 px-1 focus:outline-none focus:border-accent-400 transition-colors placeholder:text-background-50/30"
              />
              <button
                type="submit"
                className="px-5 py-2 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-background-100 transition-colors flex items-center gap-1 justify-center whitespace-nowrap cursor-pointer"
              >
                Zapisz się
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
            {submitted && (
              <p className="text-xs text-accent-400 mt-2">Dziękujemy za zapisanie się!</p>
            )}
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              Nawigacja
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/kakobuy-spreadsheet-polska/" className="text-sm text-background-50/50 hover:text-background-50/80 underline underline-offset-4 transition-colors">
                  Kakobuy Spreadsheet Polska
                </Link>
              </li>
              <li>
                <Link to="/best-kakobuy-spreadsheet-2026/" className="text-sm text-background-50/50 hover:text-background-50/80 underline underline-offset-4 transition-colors">
                  Best Kakobuy Spreadsheet 2026
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-background-50/50 hover:text-background-50/80 underline underline-offset-4 transition-colors">
                  Strona Główna
                </Link>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-polska-2026/" className="text-sm text-background-50/50 hover:text-background-50/80 underline underline-offset-4 transition-colors">
                  Artykuły
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              Kontakt
            </h4>
            <p className="text-sm text-background-50/50 mb-1">
              <a href="mailto:kontakt@kakobuyspreadsheet.wtf" className="hover:text-background-50/80 transition-colors">
                kontakt@kakobuyspreadsheet.wtf
              </a>
            </p>
            <div className="mt-6">
              <h5 className="text-xs font-semibold text-background-50/40 mb-2 uppercase tracking-wider">
                Adres
              </h5>
              <p className="text-sm text-background-50/50">
                ul. Przykładowa 123
              </p>
              <p className="text-sm text-background-50/50">
                00-001 Warszawa, Polska
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/60 underline underline-offset-4 transition-colors"
            >
              Facebook
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/60 underline underline-offset-4 transition-colors"
            >
              Instagram
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/60 underline underline-offset-4 transition-colors"
            >
              Twitter
            </a>
          </div>

          <p className="text-xs text-background-50/30 text-center">
            &copy; 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/60 underline underline-offset-4 transition-colors"
            >
              Polityka prywatności
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/60 underline underline-offset-4 transition-colors"
            >
              Regulamin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}